import { FormDropdown } from '@portal_components/components/FormDropdown';
import { FormCard } from '@portal_components/components/FormCard';
import { BulkAssignListForm, Invoice } from '../../types';

interface BulkAssignInvoiceDetailsTabProps {
  invoices: Invoice[] | undefined;
  index: number;
}

export const BulkAssignInvoiceDetailsTab = ({ invoices, index }: BulkAssignInvoiceDetailsTabProps) => {
  if (!invoices || invoices.length === 0) {
    return <div className="flex flex-row justify-center">No invoices associated to customer or contract</div>;
  }

  return (
    <FormCard>
      <FormDropdown<BulkAssignListForm>
        title="Invoice"
        name={`siteList.${index}.invoiceGroupId`}
        placeholder="Select Invoice"
        elementsForDisplay={invoices.map(invoice => ({
          title: invoice.customerInvoiceName ?? '',
          value: invoice.invoiceGroupId
        }))}
      />
    </FormCard>
  );
};
